<template>
  <div class="card-box" @click="clickEvent">
    <div class="card-img-box">
      <img :src="'/express_api' + cardData.picture_url" />
    </div>
    <div class="card-title-box">
      <div>{{ cardData.name }}</div>
      <div>{{ cardData.english_name }}</div>
    </div>
    <div class="card-info-box" v-if="isInfo">
      <div class="card-type-box">{{ cardData.breed }}</div>
      <div class="card-abv-box">{{ cardData.purity }} vol</div>
    </div>
    <!-- <div class="card-price-box">¥{{ cardData.price }}</div> -->
  </div>
</template>
<script>
export default {
  name: "Card",
  props: {
    cardData: {
      type: Object,
      default: () => {
        return {

        }
      }
    },
    isInfo: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {
    clickEvent() {
      this.$router.push({
        path: '/wineDetails',
        query: {
          id: this.cardData.id,
        }
      })
    }
  },
  mounted() {

  }
}
</script>
<style lang="scss" scoped>
.card-box {
  width: 100%;
  height: 100%;
  // line-height: 30px;
  cursor: pointer;
  text-align: center;

  .card-img-box {
    width: 100%;
    height: 300px;
    padding: 10%;
    box-sizing: border-box;

    img {
      max-width: 100%;
      max-height: 100%;
      transition: all 0.5s ease;
    }
  }
  &:hover {
    .card-img-box {
      img {
        transform: scale(1.1);
      }
    }
  }

  .card-title-box {
    font-size: 1em;
    color: #2d2a2a;
  }

  .card-info-box {
    color: #777;
    text-align: center;
  }

  .card-price-box {
    color: #B30D33;
    font-size: 1.2em;
  }
}
</style>